import { NotificationBase } from './notification-base';

export class NotificationSupportHour extends NotificationBase {
  process(): void {
    if (!this.isCurrentPage()) {
      this.showAlert();
    }
  }

  protected viewNotification(): void {
    if (this.item?.uuid) {
      this.navCtrl.navigateForward(`/support-hour/view/${this.item.uuid}`);
      return;
    }

    if (this.item?.id) {
      this.navCtrl.navigateForward(`/support-hour/view/${this.item.id}`);
      return;
    }

    console.error('[Support Hour Push Notification] No uuid or id found', this.item);
    this.navCtrl.navigateForward('/tabs/support-hour');
  }

  private isCurrentPage(): boolean {
    if (this.item?.uuid) {
      return this.currentRoute() === `/support-hour/view/${this.item.uuid}`;
    }

    if (this.item?.id) {
      return this.currentRoute() === `/support-hour/view/${this.item.id}`;
    }

    return false;
  }
}
